import ProjectList from './ProjectList';

export default function ProjectSelect({ displayProjects, setActiveProject, pathway, restoreProjectId = '', onRestoreHandled }) {

  return (
    <div style={{ width: '90%', marginBottom: '1.5rem' }}>
      <ProjectList
        displayProjects={displayProjects}
        setActiveProject={setActiveProject}
        pathway={pathway}
        restoreProjectId={restoreProjectId}
        onRestoreHandled={onRestoreHandled}
      />
    </div>
  );
}
